import Box from "@mui/material/Box";
import { styled } from "@mui/system";

export const studentDashboardSx = {
  mainBox: {
    height: { xs: "100vh", md: '95vh' },
    px: { sm: 5, xs: 2 },
    display: 'flex',
    flexDirection: { xs: 'column', sm: "column", md: 'row', lg: "row", xl: 'row' },
    gap: 2,
  },
  leftBoxWrapper: {
    width: { xs: "100%", md: "25%" },
    height: { md: "85vh" },
    pt: { xs: 5, md: 5 },
  },
  tabTypography: {
    cursor: "pointer",
  },
  rightBox: {
    overflowY: { xs: "visible", md: 'scroll' },
    '::-webkit-scrollbar': {
      display: 'none'
    },
    minHeight: { md: '85vh' },
    pt: { xs: 0, md: 5 }
  }
}

export const refundModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'white',
    borderRadius: "30px",
    boxShadow: 24,
    p: 4,
  }
export const MainBox = styled(Box)(({ theme }) => ({
    width: "100%",
}));
export const RightBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    width: "80%",
    [theme.breakpoints.down('md')]: {
        width: "100%",
    },
}));
export const LeftBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    minHeight: "auto",
    gap: "14px",
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    borderLeft: "3px solid grey",
    marginTop: "100px",
    [theme.breakpoints.down('md')]: {
        marginTop: '0',
        display: 'flex',
        flexDirection: 'row',
        border: '0px',
        paddingLeft: 0,
        flexWrap: "wrap",
    },
}));
export const ClassCard = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: "30px",
    border: "2px solid grey",
    minWidth: "200px",
    width: '330px',
    minHeight: "160px",
    height: 'auto',
    padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
        width: "100%",
    }
}));